import React from "react";
import { Redirect } from "react-router-dom";
import { Routes } from "../../../app/route/RoutesConfig";

const EmployeeHome: React.FC<{}> = () => {
  return <Redirect to={Routes.shipments.tracking} />;
}

export default EmployeeHome;